export enum TagSize {
    XSmall = 0.25,
    Small = 0.5,
    Medium = 1,
    Large = 2,
    XLarge = 4,
}